import { DocumentAssetType } from './document-asset.model';

export interface LabeledOption<T = string> {
  label: string;
  value: T;
}

// Valori canonici allineati ai consumer (contract-form, contract-action-form,
// contract-detail, contract-templates) che filtrano i template master per
// subDomainType su 'CONTRACTS' e 'ATTO_DI_NOMINA'.
export const SUB_DOMAIN_OPTIONS: LabeledOption[] = [
  { label: 'Contratto', value: 'CONTRACTS' },
  { label: 'Atto di nomina', value: 'ATTO_DI_NOMINA' },
  { label: 'Informativa privacy', value: 'PRIVACY_NOTICE' },
  { label: 'Allegato di contratto', value: 'ATTACHMENT' },
  { label: 'Articolo riusabile', value: 'ARTICLE' },
  { label: 'Altro', value: 'OTHER' },
];

export const ASSET_TYPE_OPTIONS: LabeledOption<DocumentAssetType>[] = [
  { label: 'Template master', value: 'MASTER_TEMPLATE' },
  { label: 'Allegato', value: 'ATTACHMENT' },
  { label: 'Articolo', value: 'ARTICLE' },
  { label: 'Clausola', value: 'CLAUSE' },
  { label: 'Blocco generico', value: 'GENERIC_BLOCK' },
  { label: 'Atto di nomina', value: 'ATTO_NOMINA' },
];

const SUB_DOMAIN_MAP = new Map(
  SUB_DOMAIN_OPTIONS.map((o) => [o.value.toUpperCase(), o.label]),
);
const ASSET_TYPE_MAP = new Map(
  ASSET_TYPE_OPTIONS.map((o) => [o.value.toUpperCase(), o.label]),
);

export function decodeSubDomain(value?: string | null): string {
  if (!value) return '';
  return SUB_DOMAIN_MAP.get(value.toUpperCase()) ?? value;
}

export function decodeAssetType(value?: string | null): string {
  if (!value) return '';
  return ASSET_TYPE_MAP.get(value.toUpperCase()) ?? value;
}

// Riga tabella condivisa fra Template Documentali e i dialog di selezione
// template in contract-form / contract-detail / contract-action-*.
export interface TemplateSelectionRow {
  /** businessKey — usato come value dell'opzione selezionata */
  id: string;
  name: string;
  subDomainType: string;
  versionLabel: string;
  lastModified: string;
}

export interface TemplateSelectionSource {
  businessKey: string;
  name?: string;
  subDomainType?: string;
  version?: number;
  updatedAt?: string;
  createdAt?: string;
  status?: string;
  isActive?: boolean;
}

// Difesa in profondità: la lista v2 filtra già ACTIVE + isActive, ma i dialog
// di selezione non mostrano lo stato quindi ri-filtriamo per evitare che una
// regressione lato servizio esponga versioni superseded o DRAFT.
export function isSelectableTemplate(asset: TemplateSelectionSource): boolean {
  const status = asset.status ?? 'ACTIVE';
  const active = asset.isActive ?? true;
  return status === 'ACTIVE' && active;
}

export function toTemplateSelectionRow(
  asset: TemplateSelectionSource,
): TemplateSelectionRow {
  return {
    id: asset.businessKey,
    name: asset.name || asset.businessKey,
    subDomainType: decodeSubDomain(asset.subDomainType),
    versionLabel: asset.version != null ? `v${asset.version}` : '',
    lastModified: formatItDate(asset.updatedAt ?? asset.createdAt),
  };
}

function formatItDate(value?: string): string {
  if (!value) return '-';
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? '-' : parsed.toLocaleDateString('it-IT');
}
